import groupBy from 'hs-lodash/groupBy';
import { getGroupByKeys } from 'automation-ui-log-events/components/execution-results/utils/getGroupByKeys';
export const formatExecutionResults = results => groupBy(results, getGroupByKeys);